import { FC, useRef } from 'react';

import { chevronDown } from '@purpur/library/icon/assets/chevron-down';

import { NavigationItem } from '@telialt/models/src/Navigation';
import { useComponentId } from '@telialt/utils/src/hooks';

import { useDropdownOpenClose } from '../../hooks/useDropdownOpenClose';
import { MenuItemIcon } from '../MenuItem/MenuItem.styles';
import { MenuColumn } from './MenuColumn';
import {
    MenuContainer,
    MenuContainerWrapper,
    MenuShadow,
    MenuWrapper,
    StyledMenuItemDropdown,
} from './MenuItemDropdown.styles';

interface Props {
    open: boolean;
    onOpenChange: () => void;
    item: NavigationItem;
}

export const MenuItemDropdown: FC<Props> = ({ open, onOpenChange, item }) => {
    const { title, colorOption, displayOption } = item;
    const menuRef = useRef<HTMLDivElement | null>(null);
    const buttonRef = useRef<HTMLButtonElement | null>(null);
    const { handleToggle } = useDropdownOpenClose({ open, onOpenChange, buttonRef, menuRef });
    const menuId = useComponentId('menu');

    return (
        <>
            <StyledMenuItemDropdown
                ref={buttonRef}
                $colorOption={colorOption}
                $displayOption={displayOption}
                $isActive={open}
                aria-haspopup="true"
                aria-expanded={open}
                aria-controls={menuId}
                onClick={handleToggle}
                data-section="Dropdown"
                data-section-name={title}
            >
                {title}
                <MenuItemIcon svg={chevronDown} size="sm" />
            </StyledMenuItemDropdown>
            <MenuWrapper
                ref={menuRef}
                role="menu"
                aria-label={title}
                id={menuId}
                $open={open}
                data-section="Mega Menu"
                data-section-name={title}
            >
                <MenuContainerWrapper>
                    <MenuContainer>
                        {item.children?.map((child) => (
                            <MenuColumn key={child.title} item={child} />
                        ))}
                    </MenuContainer>
                </MenuContainerWrapper>
                <MenuShadow />
            </MenuWrapper>
        </>
    );
};
